import { createSlice } from '@reduxjs/toolkit' //next js redux toolkit  
export const partialTripSlice = createSlice({
  name: 'partialTrip',
  initialState: {
    tripNumber: '',
    partialTrips: [],
    routes : [],
    movements: [],
    agendaResource : '',
    isRefreshPartialTrip : false,
    isRefreshRouteAndPT : false,
    isMultiplePT : false,
    plannedOnAgenda:false,
    removePartialTrip:false,
    guid:0,
    customView:false,
  },
  reducers: {
    setPartialTripReducer: (state, action) => {
        state.tripNumber = action.payload.tripNumber
        state.partialTrips = action.payload.partialTrips
        state.guid = action.payload?.guid
        state.customView = action.payload?.customView
        return state;
    },
    setRoutesReducer: (state, action) => {
        state.routes = action.payload
      return state;
    },
    setSmovReducer: (state, action) => {
        state.movements = action.payload
      return state;
    },
    refreshPartialTrip: (state, action) => {
      state.isRefreshPartialTrip = action.payload;
      return state;
    },
    refreshRouteAndPT: (state, action) => {
      state.isRefreshRouteAndPT = action.payload
      return state;
    },
    setAgendaResource : (state, action) => {
      state.agendaResource = action.payload
      return state;
    },
    setIsMultiplePT : (state, action) => {
      state.isMultiplePT = action.payload
      return state;
    },
    // to clear selection in partial trip grid after successfull drop on agenda
    setPlannedOnAgenda:(state, action) => {
      state.plannedOnAgenda = action.payload
      return state;
    },
    setRemovePartialTrip:(state, action) => {
      state.removePartialTrip = action.payload
      return state;
    },
  }
})
// case under reducers becomes an action 
export const { setPartialTripReducer, setRoutesReducer, setSmovReducer, refreshPartialTrip, refreshRouteAndPT, setAgendaResource, setIsMultiplePT,setPlannedOnAgenda, setRemovePartialTrip } = partialTripSlice.actions
export default partialTripSlice.reducer 
